import type { OrganizationResource } from '@/types/organizations'
import type { UserResource } from '@/types/users'

/** Signed in without an organisation and not a superadmin: nothing of their own to create events for or administer.
 *  Creating events, organisation settings and admin stay behind this test. */
export function withoutOrganization(
  organization: OrganizationResource | null | undefined,
  user: UserResource | null | undefined,
) {
  return !organization && user?.attributes.role !== 'superadmin'
}

/** A viewer, who watches events but runs none: no organisation, and no event they manage for someone else
 *  (docs/features/event-managers.md). The API's host endpoints refuse these accounts; a manager without an
 *  organisation reaches their events and those events' workspaces. */
export function isViewer(organization: OrganizationResource | null | undefined, user: UserResource | null | undefined) {
  return withoutOrganization(organization, user) && !((user?.attributes.managed_events_count ?? 0) > 0)
}
